<h3>{{ 'orders.debtors' | transloco }}</h3>
<!-- Debtors -->
@if (uiConfiguration?.hasDebtors) {
  <div class="flex-container no-margin">
    <lib-parties-list
      partyTypeTitle="Debtor"
      [order]="order"
      [observableParties$]="parties$"
      [errors$]="observableErrors$"
      class="flex-item"
      [isEditable]="isEditable"
      [uiConfiguration]="uiConfiguration!.debtorsConfiguration!"
      [expandedParty]="newParty"
      [businessPartyType]="businessDebtor"
      [individualPartyType]="individualDebtor"
      [defaultPartyType]="individualDebtor"
      (partyAddedEvent)="handlePartyAddedEvent($event)"
      (partyRemovedEvent)="handlePartyRemovedEvent($event)"
      (partyUpdatedEvent)="handlePartySavedEvent($event)"
      (partyCopiedEvent)="handlePartyCopiedEvent($event)"
      (partyFormValueChangedEvent)="handlePartyFormValueChangedEvent($event)">
    </lib-parties-list>
  </div>
}